import React, { Component } from 'react';
import { getGlobalStorage, theme, getLangCode } from '@platform/api';
import classnames from 'classnames';
import { hexToHsl } from '../../adapter/utils';
import './index.less';

let langCode = getLangCode(),
    isEnglish = langCode !== 'simpchn' && langCode !== 'tradchn';

export default function useStyle(Table) {

    return class StyleTable extends Component {
        componentDidMount() {

            // this.execThemeColor();

            // theme.addListener('tableColor', this.execThemeColor);
        }

        componentWillUnmount() {
            theme.removeListener('tableColor');
        }

        //给表头和选中行添加主题色(这两个在个性化设置里有自己的设置，不完全跟着主题色走) 
        execThemeColor = () => {
            this.generateThemeColor("selectRowColor");
            this.generateThemeColor("headerColor");
        }

        generateThemeColor = type => {
            let globalTableConfig = JSON.parse(getGlobalStorage('localStorage', 'nccTable')) || {};
            let {
                customSetting,
                id,
                store,
            } = this.props;
            let { selectedrowcolor, tablehdbgcolor } = { ...globalTableConfig, ...customSetting };
            let level;
            let element, basicColor, hslColor = {}, h, s, l, isBlackTheme;
            let uuid = store.getInstance()?.uuid;
            let table = document.querySelector(`div[uuid='${uuid}']`);
            if (!table) { return; }
            element = table.querySelector('.base-table-next .table-next-header tr th');
            switch (type) {
                case "selectRowColor":
                    basicColor = '#e9f0fa';
                    if (element) {
                        if (this.getStyle(element, '--pui-black-derived-color-8')) { //暗黑
                            isBlackTheme = true;
                            basicColor = this.getStyle(element, '--pui-black-derived-color-8');
                        } else {
                            basicColor = this.getStyle(element, '--pui-derived-color-5') || '#e9f0fa';
                        }
                    }
                    level = selectedrowcolor;
                    break;

                case "headerColor":
                    if (element) {
                        if (this.getStyle(element, '--pui-black-derived-color-6')) { //暗黑
                            isBlackTheme = true;
                            basicColor = this.getStyle(element, '--pui-black-derived-color-6');
                        } else {
                            basicColor = this.getStyle(element, '--pui-derived-color-6') || '#F7F9FD';
                        }
                    }
                    level = tablehdbgcolor;
                    break;
            }

            hslColor = hexToHsl(basicColor);
            h = hslColor.h;
            s = hslColor.s;
            if (level === "norm") {
                l = isBlackTheme ? hslColor.l + 3 : hslColor.l - 3;
            } else if (level === "dark") {
                l = isBlackTheme ? hslColor.l + 6 : hslColor.l - 6;
            } else {
                l = hslColor.l;
            }

            if (type == "selectRowColor") {
                table.style.setProperty('--theme-select-row', `hsl(${h}deg,${s}%,${l}%)`);
            }
            if (type == "headerColor") {
                table.style.setProperty('--theme-header', `hsl(${h}deg,${s}%,${l}%)`);
            }

        }

        getStyle = (element, value) => {
            return window.getComputedStyle(element).getPropertyValue(value).trim();
        }

        render() {
            let globalTableConfig = JSON.parse(getGlobalStorage('localStorage', 'nccTable')) || {};
            let { flex, customSetting } = this.props;
            globalTableConfig = { ...globalTableConfig, ...customSetting };
            let {
                crossCheck = false, // 是否斑马线
                cuttingCheck = true, // 是否分割线
                tableType = 'standard',
            } = globalTableConfig;
            //这里主要是为了实时预览使用
            // if(customSetting.selectedrowcolor) { 
            // this.generateThemeColor("selectRowColor");  
            // }
            // if(customSetting.tablehdbgcolor) {
            // this.generateThemeColor("headerColor");
            // }
            return <div
                className={classnames("table-style-wrapper", {
                    'crossing-style': crossCheck,
                    'split-style': cuttingCheck,
                    'flex-container': flex,
                    [`table-style-${tableType}`]: true,
                    'is-english': isEnglish,
                })}
            >
                <Table {...this.props}></Table>
            </div>;
        }
    };
}

useStyle.displayName = 'useStyle';
useStyle.dependence = [];